import React from "react";
import { Link } from "react-router-dom";
import Services from "../components/Services";

export default function ServicesPage() {
  const serviceData = [
    { title: "Architecture", img: "/images/whychooseus/third.jpg" },
    { title: "Interior", img: "/images/whychooseus/first.png" },
    { title: "Turnkey solutions", img: "/images/home/trunky.png" },
  ];

  return (
    <div className="w-full">
     

      {/* Services Section */}
      <section className="py-5 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Our Services</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {serviceData.map((service, idx) => (
              <div
                key={idx}
                className="relative h-96 rounded-xl overflow-hidden shadow-lg transform transition duration-500 hover:scale-105 group"
              >
                {/* Image */}
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />

                {/* Always visible black overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-40"></div>

                {/* Text always visible */}
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4 z-10 text-white">
                  <h3 className="text-2xl font-bold mb-2">{service.title}</h3>
                </div>

                {/* Modern hover effect (e.g., subtle light shine from top-left) */}
                <div className="absolute inset-0 pointer-events-none bg-gradient-to-tl from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Dummy Content Section below Services */}
      <section className="py-10 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Explore Our Expertise
          </h2>
          <p className="text-gray-700 text-lg md:text-xl max-w-3xl mx-auto mb-8">
            We specialize in providing tailored solutions that meet your
            specific needs. From modern architecture to interior design, our
            team delivers excellence in every project.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition duration-300">
              <h3 className="text-xl font-bold mb-2">Creative Design</h3>
              <p className="text-gray-600">
                Innovative designs that transform spaces and enhance your
                lifestyle.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition duration-300">
              <h3 className="text-xl font-bold mb-2">Quality Construction</h3>
              <p className="text-gray-600">
                We use premium materials and expert craftsmanship for every
                project.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition duration-300">
              <h3 className="text-xl font-bold mb-2">Customer Support</h3>
              <p className="text-gray-600">
                Our team ensures a smooth and satisfying experience from start
                to finish.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
